import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import DataTableNew from 'components/new_ui/Table';

import Filters from './Table/Filters';
import columns from './Table/columns';
import data from './Table/data';
import { useContext } from './Context';
// import InvitePopup from './Invite/Popup';

export default function Table({ scope }) {
  const { dispatch, actions, state } = useContext();
  const [keyword, setKeyword] = useState('');
  const [systemStatus, setSystemStatus] = useState(null);
  const [billingStatus, setBillingStatus] = useState(null);
  const [paymentVerification, setPaymentVerification] = useState(null);
  // const [selectedAffiliate, setSelectedAffiliate] = useState(null);

  useEffect(() => {
    actions.load(dispatch, scope);
  }, []);

  // const inviteAffiliate = (affiliate) => {
  //  setSelectedAffiliate(affiliate);
  // };

  return (
    <>
      <Filters
        keyword={keyword}
        setKeyword={setKeyword}
        setSystemStatus={setSystemStatus}
        setBillingStatus={setBillingStatus}
        setPaymentVerification={setPaymentVerification}
      />
      <div className="datatable-style with-actions">
        <DataTableNew
          title=" "
          columns={columns(scope)}
          data={data(state.coaches, keyword, systemStatus, billingStatus, paymentVerification) || []}
          loading={state.coaches == null}
          selectableRows={false}
        />
      </div>
    </>
  );
}

Table.propTypes = {
  scope: PropTypes.string.isRequired,
};
